/**
 * Prefix every MFA error key the backend returns carries, e.g. "[MFA] CHALLENGE_CODE_INVALID".
 *
 * Used to recognise an MFA failure by its body rather than by the URL it came from: `POST /Auth/login`
 * itself can answer 401 [MFA] SESSION_EXPIRED when an enrollment disappears between the password
 * check and the challenge opening, and that URL matches no MFA endpoint prefix.
 */
export const MFA_ERROR_KEY_PREFIX = '[MFA] ';
